<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
import {app} from './main'
import Vue from 'vue'
import liff from '@line/liff';

import VConsole from 'vconsole';

export default {
    name: 'App',
    data () {
        return {
          profile:null,
          AccessToken:'',
          DecodedIDToken:null,

        }
    },
    methods:{
        //語言
        changeLang(lang){
            app.$i18n.locale=lang
        },
        //Axios
        getValue(){
            const vm =this;
            const api =`${process.env.APIPATH}/posts`;
            //  console.log(process.env.APIPATH,process.env.APIPSD)
            this.$http.get(api).then((response) => {
                console.log(response.data)
                this.value =  response.data;
            })
        }
    },
    mounted(){
        // const vConsole = new VConsole();

    },
    created(){
    }
  
}
</script>


<style lang="scss">
    @import './assets/scss/all';
</style>




// WEBPACK FOOTER //
// src/App.vue